import { Model } from '@/models/Model';
import { QueryClient, QueryKey } from '@tanstack/react-query';
import { CacheStrategy } from './CacheStrategy';

export class SingleCacheStrategy<T extends Model> implements CacheStrategy<T> {
  constructor(
    protected queryClient: QueryClient,
    protected queryKey: QueryKey,
  ) {}

  get(): T | undefined {
    return this.queryClient.getQueryData<T>(this.queryKey);
  }

  set(data: T): void {
    this.queryClient.setQueryData(this.queryKey, data);
  }

  merge(data: Partial<T>): void {
    const current = this.get();
    if (current) {
      this.queryClient.setQueryData(this.queryKey, { ...current, ...data });
    }
  }

  remove(): void {
    this.queryClient.removeQueries({ queryKey: this.queryKey });
  }
}
